import { isEmail } from 'Utils/Validators/email'
import { isOnboardingUrl } from '../../../../../Utils/Validators/onboardingUrl'

export const validateCityDataPayload = data => {
  if (data.recruitmentCalendarId && !isEmail(data.recruitmentCalendarId)) {
    alert(
      `Invalid recruitment calendar id. Should be in a correct email format.`,
    )
    return false
  } else if (data.onboardingUrl && !isOnboardingUrl(data.onboardingUrl)) {
    alert(
      `Invalid Online Meeting URL
      Should be in a correct format. E.g. meet.google.com/aaa-bbbb-ccc`,
    )
    return false
  } else return true
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityAddEdit/util/validators.js